export default __webpack_public_path__ + "static/media/IMG_9938.cf350071.jpg";